import { render } from "./confirm-subscription.vue?vue&type=template&id=020b1944"
import script from "./confirm-subscription.vue?vue&type=script&lang=js"
export * from "./confirm-subscription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__